module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/limit-flow-proposal/component/limit-flow-proposal/redirect-flow-committee-modal/redirect-flow-committee-modal/redirect-flow-committee-modal.component.scss
// module id = ./src/app/limit-flow-proposal/component/limit-flow-proposal/redirect-flow-committee-modal/redirect-flow-committee-modal/redirect-flow-committee-modal.component.scss
// module chunks = main